/**
 * Created by olga on 04.12.2025
 */

const NewTaskWindow = Prefab.createWindow("new_task_window", "newtaskwindow_prefab_json");